"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFoldersSuccess = fetchFoldersSuccess;
exports.searchFolders = exports.fetchFolderById = exports.fetchInitialFolderById = exports.fetchInitialFolderByPath = exports.fetchFoldersByParentId = exports.buildFolderPayload = exports.buildFolderMap = exports.buildFolderFromAttrs = void 0;

var _immutable = require("immutable");

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var RequestType = _interopRequireWildcard(require("../enums/RequestType"));

var _Constants = require("../Constants");

var _logging = require("../utils/logging");

var foldersApi = _interopRequireWildcard(require("../api/FolderFetch"));

var FileSearchApi = _interopRequireWildcard(require("../api/FileSearch"));

var _Folders = require("../selectors/Folders");

var _Api = require("../constants/Api");

var _stringUtils = require("../utils/stringUtils");

var _Auth = require("../selectors/Auth");

var _FileSearch2 = require("./FileSearch");

var buildFolderFromAttrs = function buildFolderFromAttrs(attrs) {
  attrs.category = _Constants.ObjectCategory.FOLDER;
  return (0, _immutable.fromJS)(attrs);
};

exports.buildFolderFromAttrs = buildFolderFromAttrs;

var buildFolderMap = function buildFolderMap(objects) {
  return (0, _immutable.OrderedMap)(objects.map(function (attrs) {
    return [attrs.id, buildFolderFromAttrs(attrs)];
  }));
};

exports.buildFolderMap = buildFolderMap;

var buildFolderPayload = function buildFolderPayload(resp) {
  return (0, _immutable.Map)(Object.assign({}, resp, {
    objects: buildFolderMap(resp.objects)
  }));
};

exports.buildFolderPayload = buildFolderPayload;

var buildFolderSearchResponsePayload = function buildFolderSearchResponsePayload(resp) {
  var data = (0, _FileSearch2.buildResponsePayload)(resp, _Constants.ObjectCategory.FOLDER);
  return data.set('total_count', data.get('total'));
};

function fetchFoldersAttempt(_ref) {
  var initialFetch = _ref.initialFetch,
      requestType = _ref.requestType,
      requestLookupKey = _ref.requestLookupKey;
  return {
    type: ActionTypes.FETCH_FOLDERS_ATTEMPTED,
    status: _Constants.RequestStatus.PENDING,
    initialFetch: initialFetch,
    requestType: requestType,
    requestLookupKey: requestLookupKey
  };
}

function fetchFoldersSuccess(data) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$initialFetch = _ref2.initialFetch,
      initialFetch = _ref2$initialFetch === void 0 ? false : _ref2$initialFetch,
      requestType = _ref2.requestType,
      requestLookupKey = _ref2.requestLookupKey;

  return {
    type: ActionTypes.FETCH_FOLDERS_SUCCEEDED,
    status: _Constants.RequestStatus.SUCCEEDED,
    data: data,
    initialFetch: initialFetch,
    requestType: requestType,
    requestLookupKey: requestLookupKey
  };
}

function searchFoldersSuccess(data, searchTerm, _ref3) {
  var _ref3$initialFetch = _ref3.initialFetch,
      initialFetch = _ref3$initialFetch === void 0 ? false : _ref3$initialFetch;
  return {
    type: ActionTypes.FETCH_FOLDERS_SUCCEEDED,
    status: _Constants.RequestStatus.SUCCEEDED,
    data: data,
    initialFetch: initialFetch,
    requestType: RequestType.bySearchTerm,
    requestLookupKey: searchTerm
  };
}

function fetchFoldersFailed(_ref4) {
  var initialFetch = _ref4.initialFetch,
      _ref4$status = _ref4.status,
      status = _ref4$status === void 0 ? _Constants.RequestStatus.FAILED : _ref4$status,
      requestType = _ref4.requestType,
      requestLookupKey = _ref4.requestLookupKey;
  return {
    type: ActionTypes.FETCH_FOLDERS_FAILED,
    status: status,
    initialFetch: initialFetch,
    requestType: requestType,
    requestLookupKey: requestLookupKey
  };
}

var fetchFoldersByParentId = function fetchFoldersByParentId(parentFolderId) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref5$initialFetch = _ref5.initialFetch,
      initialFetch = _ref5$initialFetch === void 0 ? false : _ref5$initialFetch,
      hostApp = _ref5.hostApp;

  return function (dispatch, getState) {
    parentFolderId = parentFolderId || _Constants.ROOT_FOLDER_ID;

    if ((0, _Folders.hasFolderRequestSucceeded)(getState(), RequestType.byParentId, parentFolderId)) {
      return null;
    }

    dispatch(fetchFoldersAttempt({
      initialFetch: initialFetch,
      requestType: RequestType.byParentId,
      requestLookupKey: parentFolderId
    }));
    var fetchOptions = {
      hostApp: hostApp,
      parent_folder_id: parentFolderId === _Constants.ROOT_FOLDER_ID ? 'None' : parentFolderId
    };
    return foldersApi.fetchFolders(fetchOptions).then(function (subfolderData) {
      subfolderData = buildFolderPayload(subfolderData);

      if (subfolderData.get('total_count') > _Api.FOLDER_BY_PARENT_REQUEST_LIMIT) {
        if (subfolderData.get('total_count') > _Api.FOLDER_BY_PARENT_CUTOFF) {
          (0, _logging.reportMessage)('Found more folders within a parent than we will load', {
            total: subfolderData.get('total_count'),
            limit: _Api.FOLDER_BY_PARENT_CUTOFF,
            parentFolderId: parentFolderId
          });
        }

        if (initialFetch) {
          return foldersApi.fetchFolders(Object.assign({}, fetchOptions, {
            offset: _Api.FOLDER_BY_PARENT_REQUEST_LIMIT
          })).then(function (remainingFolderData) {
            var remainingFolders = buildFolderMap(remainingFolderData.objects);
            subfolderData = subfolderData.updateIn(['objects'], function (objects) {
              return objects.merge(remainingFolders);
            });
            dispatch(fetchFoldersSuccess(subfolderData, {
              requestType: RequestType.byParentId,
              requestLookupKey: parentFolderId,
              initialFetch: initialFetch
            }));
            return subfolderData;
          });
        }
      }

      dispatch(fetchFoldersSuccess(subfolderData, {
        requestType: RequestType.byParentId,
        requestLookupKey: parentFolderId,
        initialFetch: initialFetch
      }));
      return subfolderData;
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: ActionTypes.FETCH_FOLDERS_FAILED,
        parentFolderId: parentFolderId,
        initialFetch: initialFetch
      });
      dispatch(fetchFoldersFailed({
        requestType: RequestType.byParentId,
        requestLookupKey: parentFolderId,
        initialFetch: initialFetch
      }));
    });
  };
};

exports.fetchFoldersByParentId = fetchFoldersByParentId;

var fetchInitialFolderByPath = function fetchInitialFolderByPath(folderPath) {
  return function (dispatch) {
    dispatch(fetchFoldersAttempt({
      initialFetch: true
    }));
    return foldersApi.fetchFolderWithBreadcrumbs(folderPath).then(function (data) {
      var objects = buildFolderMap(data);
      var resp = (0, _immutable.Map)({
        objects: objects,
        total: objects.size
      });
      var initialFolder = objects.find(function (f) {
        return f.get('full_path') === (0, _stringUtils.addLeadingSlashToPath)(folderPath);
      });

      if (!initialFolder) {
        throw new Error('Could not find initial folder by path');
      }

      dispatch(fetchFoldersSuccess(resp, {
        initialFetch: true
      }));
      return initialFolder;
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'FETCH_FOLDER_WITH_BREADCRUMBS_BY_PATH_FAILED',
        folderPath: folderPath
      });
      dispatch(fetchFoldersFailed({
        initialFetch: true,
        status: _Constants.RequestStatus.NOTFOUND
      }));
      throw err;
    });
  };
};

exports.fetchInitialFolderByPath = fetchInitialFolderByPath;

var fetchInitialFolderById = function fetchInitialFolderById(folderId) {
  return function (dispatch) {
    dispatch(fetchFoldersAttempt({
      initialFetch: true,
      requestType: RequestType.byParentId,
      requestLookupKey: folderId
    }));
    foldersApi.fetchFolderWithBreadcrumbs(folderId).then(function (data) {
      var objects = buildFolderMap(data);
      var resp = (0, _immutable.Map)({
        objects: objects,
        total: objects.size
      });
      dispatch(fetchFoldersSuccess(resp, {
        initialFetch: true,
        requestType: RequestType.byParentId,
        requestLookupKey: folderId
      }));
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'FETCH_FOLDER_WITH_BREADCRUMBS_BY_ID',
        folderId: folderId
      });
      dispatch(fetchFoldersFailed({
        initialFetch: true,
        status: _Constants.RequestStatus.NOTFOUND,
        requestType: RequestType.byParentId,
        requestLookupKey: folderId
      }));
    });
  };
};

exports.fetchInitialFolderById = fetchInitialFolderById;

var fetchFolderById = function fetchFolderById(id) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$withBreadcrumbs = _ref6.withBreadcrumbs,
      withBreadcrumbs = _ref6$withBreadcrumbs === void 0 ? false : _ref6$withBreadcrumbs;

  return function (dispatch) {
    if (withBreadcrumbs) {
      foldersApi.fetchFolderWithBreadcrumbs(id).then(function (data) {
        var resp = (0, _immutable.Map)({
          objects: buildFolderMap(data)
        });
        dispatch(fetchFoldersSuccess(resp, {
          requestType: RequestType.parentBreadcrumbs,
          requestLookupKey: id
        }));
      }).catch(function (err) {
        (0, _logging.reportError)(err, {
          type: 'FETCH_FOLDER_WITH_BREADCRUMBS_FAILED'
        });
      });
      return;
    }

    foldersApi.fetchSingleFolder(id).then(function (resp) {
      var data = buildFolderFromAttrs(resp);
      dispatch({
        type: ActionTypes.FETCH_FOLDER_SUCCEEDED,
        data: data
      });
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'FETCH_FOLDER_FAILED'
      });
    });
  };
};

exports.fetchFolderById = fetchFolderById;

var searchFolders = function searchFolders(searchTerm) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref7$initialFetch = _ref7.initialFetch,
      initialFetch = _ref7$initialFetch === void 0 ? false : _ref7$initialFetch,
      hostApp = _ref7.hostApp,
      initialFolderId = _ref7.initialFolderId;

  return function (dispatch, getState) {
    var options = {
      search: searchTerm,
      hostApp: hostApp
    };

    if (initialFetch) {
      if (initialFolderId) {
        dispatch(fetchInitialFolderById(initialFolderId));
      } else {
        dispatch(fetchFoldersByParentId(_Constants.ROOT_FOLDER_ID));
      }
    }

    if (!searchTerm) {
      return;
    }

    if ((0, _Folders.hasFolderRequestInitialized)(getState(), RequestType.bySearchTerm, searchTerm)) {
      return;
    }

    dispatch(fetchFoldersAttempt({
      requestType: RequestType.bySearchTerm,
      requestLookupKey: searchTerm
    }));

    if (!(0, _Auth.getIsUngatedForBypassElasticSearch)(getState())) {
      FileSearchApi.fetchFoldersFromSearch(options).then(function (data) {
        data = buildFolderSearchResponsePayload(data);
        dispatch(searchFoldersSuccess(data, searchTerm, {
          initialFetch: initialFetch
        }));
      });
      return;
    }

    foldersApi.fetchFolders(options).then(function (data) {
      data = buildFolderPayload(data);
      return dispatch(searchFoldersSuccess(data, searchTerm, {
        initialFetch: initialFetch
      }));
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: 'FETCH_FOLDERS_BY_QUERY_FAILED'
      });
    });
  };
};

exports.searchFolders = searchFolders;